import React from "react";

import { Avatar as AntAvatar } from "antd";

import { Icon } from "components";

export const Avatar = ({ className = "", size = "s", name, defaultIconSize = null, dataTestId = "" }) => {
  const colors = ["rapeseed", "sky-blue"];

  const getSize = () => {
    if (size === "xl") {
      return 180;
    }
    if (size === "l") {
      return 160;
    }
    if (size === "m") {
      return 72;
    }
    if (size === "xm") {
      return 56;
    }
    if (size === "xs") {
      return 32;
    }
    return 48;
  };

  return (
    <AntAvatar
      data-testid={dataTestId}
      size={getSize()}
      className={name && name !== "null" ? `${colors[name.charCodeAt(name.length - 1) % colors.length]} ${className}` : `grey ${className}`}
    >
      {name && name !== "null" ? <span className={size}>{name.charAt(0).toUpperCase()}</span> : <Icon iconName="klim/avatar" size={defaultIconSize || "xl"} />}
    </AntAvatar>
  );
};
